import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import SearchTable from '@/components/SearchTable.vue';
import _ from 'lodash';
import VueMarkdown from 'vue-markdown';
import BackButton from '@/components/BackButton.vue';
const starshipEquipmentModule = namespace('starshipEquipment');
let StarshipsEquipment = class StarshipsEquipment extends Vue {
    constructor() {
        super(...arguments);
        this.initialSearch = '';
        this.tableType = 'Starship Equipment';
    }
    created() {
        this.fetchStarshipEquipment();
        this.initialSearch = this.$route.query.search;
    }
    get items() {
        return _(this.starshipEquipment)
            .map(starshipEquipment => ({
            ...starshipEquipment,
            id: starshipEquipment.name,
            isExpandable: starshipEquipment.description
        })).value();
    }
    get headers() {
        return [
            { text: 'Name', value: 'name' },
            { text: 'Cost', value: 'cost' },
            {
                text: 'Type',
                value: 'type',
                filterChoices: ['Ammunition', 'Armor', 'Hyperdrive', 'Power Coupling', 'Reactor', 'Shield'],
                isMultiSelect: true,
                filterFunction: ({ type }, filterValue) => _.some(filterValue, (filter) => filter === _.startCase(type)),
                render: (type) => _.startCase(type)
            }
        ];
    }
};
__decorate([
    starshipEquipmentModule.State
], StarshipsEquipment.prototype, "starshipEquipment", void 0);
__decorate([
    starshipEquipmentModule.Action
], StarshipsEquipment.prototype, "fetchStarshipEquipment", void 0);
StarshipsEquipment = __decorate([
    Component({
        components: {
            SearchTable,
            BackButton,
            VueMarkdown
        }
    })
], StarshipsEquipment);
export default StarshipsEquipment;
